<template>
    <v-dialog width="500px" :value="value" @input="toggleModal" persistent scrollable >
        <v-card class="kbLight">
            <v-toolbar class="kbPink" dark flat>
                <div class="text-h6">{{ $t('general.changePassword') }}</div>
                <v-spacer></v-spacer>
                <v-btn icon @click="toggleModal(false)">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-form v-model="validUser" ref="editUserForm" lazy-validation>
                    <v-row>
                        <v-col cols="12">
                            {{ $t('general.youAreAboutToChangeUserPassword', {user: formUser.name}) }}
                        </v-col>
                        <v-col cols="12">
                            <v-text-field :label="$t('login.newPassword')"
                                          color="kbDarkBlue"
                                          v-model="formUser.password"
                                          :rules="[rules.required, rules.min8]"
                                          :type="hidePassword ? 'password' : 'text'"
                                          :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
                                          @click:append="hidePassword = !hidePassword">
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="!showChangePassword"
                       class="mr-2"
                       color="red"
                       outlined
                       @click="toggleModal(false)">{{ $t('general.cancel') }}</v-btn>
                <v-btn color="kbPink"
                       dark
                       :loading="editingUser"
                       @click="submit">{{ $t('general.saveChanges') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
export default {
  data () {
    return {
      editingUser: false,
      validUser: false,
      formUser: {
        name: '',
        password: ''
      },
      hidePassword: true,
      rules: rules,
      showChangePassword: false
    }
  },
  methods: {
    submit () {
      if (!this.$refs.editUserForm.validate()) return
      this.editingUser = true
      this.$store.dispatch('updateUser', {
        password: this.formUser.password,
        userId: this.user
      }).then(() => {
        notifications.success('Contraseña cambiada correctamente')
        this.editingUser = false
        this.toggleModal(false)
      }).catch(error => {
        notifications.error(error.message)
        this.editingUser = false
      })
    },
    toggleModal (value) {
      this.showChangePassword = false
      this.$refs.editUserForm.reset()
      this.$emit('clearSelectedUser')
      this.$emit('input', value)
    }
  },
  props: ['user', 'value'],
  watch: {
    user (user) {
      if (this.value && user) {
        this.$store.dispatch('getUserInfo', { userId: user }).then(response => {
          this.formUser.name = response.name
        }).catch(error => {
          notifications.error(error.message)
        })
      }
    }
  }
}
</script>
